<div class="filter-type-header">
  <div class="filter-type-header-text">
  {{ name ()}}
  </div>
  <lib-button (buttonClick)="resetClicked()" [type]="ButtonType.tertiary" [size]="InputSize.small" [hidden]="shouldHideButton()" i18n>Reset</lib-button>
</div>
